import { use } from 'react';

import { FeatureToggleContext } from '../context/feature-toggle-context';

export const useFeatureToggle = (toggleName: string, defaultValue = false): boolean => {
   const context = use(FeatureToggleContext);
   return context.find((toggle) => toggle.name === toggleName)?.allowed ?? defaultValue;
};
